module.exports = __webpack_public_path__ + "static/media/clear-icon.6092cc80.svg";